<template>
  <div>
    <IframeView :name="name" :url="`${baseUrl}/${name}`" :content-styles="contentStyles"
      :subContentStyles="subContentStyles" />
  </div>
</template>

<script setup>
import IframeView from '@/components/IframeView.vue';

const name = 'custom-protective-windows';
const baseUrl = `${process.env.VUE_APP_WEBSITE_URL}/landing_page`;
const contentStyles = '';
const subContentStyles = '';
</script>